import styled from 'styled-components';

export const Wrapper = styled.div`
  margin: 100px auto;
  width: 340px;
  height: 540px;
  display: flex;
  align-items: center;
  flex-direction: column;
`;
